// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadHeroCard-cls1__h3","cls2":"DownloadHeroCard-cls2_Y4m DownloadHeroCard-cls1__h3"};